import { datePadding } from '../../../utils/CalendarUtils';
import Text from '@hfe/max-text';
import { createElement, memo } from '@max/max';
import '../../../index.scss';
import '../calendar.scss';
const isMRN = false;
const CalendarMonthHeader = ({ year, month }) => {
    return <Text className="calendedar-month-header">
      <Text className="calendedar-month-header-year">{year}</Text>
      年
      <Text className="calendedar-month-header-month">{datePadding(month)}</Text>
      月
    </Text>;
};
export default memo(CalendarMonthHeader);
